/* Align server-rendered cards without delaying their display or loading products. */
(() => {
  if (window.lfdProductCardLayout) return;
  window.lfdProductCardLayout = true;
  const groups = new Map();
  const names = ['heading', 'stock', 'purchase'];
  let frame;
  const align = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      for (const [group, record] of groups) {
        if (!group.isConnected) {
          record.observer.disconnect();
          groups.delete(group);
          continue;
        }
        const cards = [...group.querySelectorAll('.lfd-catalog-card')].filter(card => card.offsetWidth > 0);
        names.forEach(name => group.style.setProperty(`--lfd-${name}-height`, '0px'));
        const heights = names.map(name => Math.ceil(Math.max(0, ...cards.map(card => card.querySelector(`.lfd-bestseller-${name}-row`)?.getBoundingClientRect().height || 0))));
        names.forEach((name, i) => group.style.setProperty(`--lfd-${name}-height`, `${heights[i]}px`));
      }
    });
  };
  const discover = root => {
    const cards = [...(root.matches?.('.lfd-catalog-card') ? [root] : []), ...root.querySelectorAll('.lfd-catalog-card')];
    for (const card of cards) {
      // The automatic carousel manages its own lifecycle and alignment.
      if (card.closest('lfd-product-bestsellers, quick-add-modal')) continue;
      const group = card.closest('.swiper-wrapper, .collection-product-list, .product-grid-list, .products-grid__wrapper') || card.closest('.shopify-section');
      if (!group) continue;
      card.parentElement?.classList.add('lfd-catalog-item');
      if (!groups.has(group)) {
        const widths = new WeakMap();
        const observer = new ResizeObserver(entries => {
          if (entries.some(entry => {
            const changed = widths.get(entry.target) !== entry.contentRect.width;
            widths.set(entry.target, entry.contentRect.width);
            return changed;
          })) align();
        });
        observer.observe(group);
        groups.set(group, { observer });
      }
      groups.get(group).observer.observe(card);
    }
    if (cards.length) align();
  };
  discover(document);
  document.fonts?.ready.then(align);
  new MutationObserver(mutations => {
    for (const mutation of mutations) for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) discover(node);
    }
    if (mutations.some(mutation => mutation.removedNodes.length)) align();
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => discover(event.target));
  document.addEventListener('shopify:section:unload', align);
})();
